import { render, staticRenderFns } from "./siteRank.vue?vue&type=template&id=54edd88e&scoped=true&"
import script from "./siteRank.vue?vue&type=script&lang=js&"
export * from "./siteRank.vue?vue&type=script&lang=js&"
import style0 from "./siteRank.vue?vue&type=style&index=0&id=54edd88e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54edd88e",
  null
  
)

export default component.exports